<div class="theme-container">
  <div class="theme-container-inner">
    <!-- Page Breadcrumb Start -->
    <div class="breadcrumb-main">
      <div class="breadcrumb-Skelton-section"  *ngIf="FleetList.isSkeltonSubpool">
        <div class="breadcrumb__left"> 
        <h1 class="sektion-filter"><span class="Skelton-pp"></span></h1>
        </div>
        
        
      </div>
      <snl-breadcrumb  *ngIf="!FleetList.isSkeltonSubpool">
        <div left-side> 
          <h1 class="header-h1 fw-700 color__primary">{{FleetList.fleet}} Fleet</h1>
        </div> 
        
      </snl-breadcrumb>
    </div>
    <!-- Page Breadcrumb End -->
   
    
    <!-- Container Card Start -->
    <div class="CommonContainerCard mt_0 p-10">
      <div class="page-tab page-tab-customize" id="subpoolSection">
        <div *ngIf="FleetList.isSkeltonSubpool" class="subpool-sektion">
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
        </div>
        <app-sub-pool *ngIf="!FleetList.isSkeltonSubpool"  [vessels]="FleetList.vessels" [subPools]="FleetList.subPoolList" (onPageTabClick)="onPageTabClick($event)" (refreshSubpool)="refreshSubpool($event)" class=" scroll thin-scroll-x subpool-div"  ></app-sub-pool>
      </div>
      <div class="action-panel-main" *ngIf="!FleetList.iNotShip">
        <snl-action-panel *ngIf="!FleetList.isSkelton">
          <div left-side class="CommonFiltersPanel df-c"> 
            <div class="ResetFiltersTxt body-b2 fw-700 df-c justify-content-start col-gap-8">
              <span class="color__black">Filters</span>
              <a href="javascript:void(0);" class="ResetAllTxt"  [ngClass]="{'active': resetActivate() == true}" class="ResetAllTxt" (click)="resetAll()">Reset all</a>
            </div> 
            <div class="FiltersHolder">
              <div class="dropdown-col _TextFltr _TextSubPool" *ngIf="FleetList.tab == 'all'" >
                  <snl-dropdown [label]="'Subpool'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                [options]="FleetList.subpool" 
                [preSelectedItems]="subPools"
                (selectedValues)="selectedValues($event,'subpool')"
                (resetDropdown) ="resetDropdown($event,'subpool')"           
                [multiple]="true"></snl-dropdown>
              </div>

              <div class="dropdown-col _TextFltr _TextClass">
                 <snl-dropdown [label]="'Class'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                [options]="FleetList.vslClass" 
                [preSelectedItems]="vslClasses"
                (selectedValues)="selectedValues($event,'vslClass')"
                (resetDropdown) ="resetDropdown($event,'vslClass')"           
                [multiple]="true"></snl-dropdown>
              </div>

              <div class="dropdown-col _TextFltr _TextShipOwnerSTJS">
                 <snl-dropdown [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                [options]="FleetList.shipOwners" 
                [preSelectedItems]="shipOwners"
                (selectedValues)="selectedValues($event,'shipOwners')"
                (resetDropdown) ="resetDropdown($event,'shipOwners')"
                [multiple]="true"></snl-dropdown>
              </div>
            
              <div class="dropdown-col _TextFltr _TextStatus">
                 <snl-dropdown
                    *ngIf="FleetList.status.length > 0"
                    [label]="'Status'" 
                    [buttonPrimary]="'Apply'" 
                    [buttonSecondary]="'Clear'"
                    [options]="FleetList.status" 
                    [preSelectedItems]="fleetStatus"
                    (selectedValues)="selectedValues($event,'status')"
                    (resetDropdown) ="resetDropdown($event,'status')"
                    [multiple]="true">
                  </snl-dropdown>
              </div>
              <app-search-input *ngIf="FleetList.searchInput"
                [label]="'Search by Ship'"
                [data]="FleetList.ship"
                [searchText] = "FleetList.searchText"
                (searchValue) = "valuechange($event)"
              ></app-search-input>               
            </div>
          </div> 
        </snl-action-panel>
        <div class="Skelton-section" *ngIf="FleetList.isSkelton">
          <div class="sektion-filter"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
        </div> 
      </div>
     
      <!-- Table Section  -->
      <div class="border__radius4 border-body-tbl table-main stjs-table table-custom-2 stjs-fleet-table-overflow"> 
        <ng-container>
          <snl-table>
            <snl-row *ngIf="!FleetList.iNotShip">
              <snl-th>
                <snl-checkbox [intermediate] ="stjsintermediate()" [checked]="filters['vslNumber'].length > 0" (onClick)="selectAll();$event.stopPropagation()" th_checkbox ></snl-checkbox>
                <span>Ship</span>
              </snl-th>
              <snl-th *ngIf="FleetList.tab == 'all'" [ngClass]="{ 'active':(FleetList.sortBy == 'subPool') }" [icon]= "(FleetList.sortBy == 'subPool' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('subPool', FleetList.sortBy == 'subPool' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')">
                <span class="oneliner-width">Sub Pool</span>
              </snl-th>
              <snl-th [ngClass]="{ 'active':(FleetList.sortBy == 'vslClass') }" [icon]= "(FleetList.sortBy == 'vslClass' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('vslClass', FleetList.sortBy == 'vslClass' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')">
                <span>Class</span>
              </snl-th>
              <snl-th [ngClass]="{ 'active':(FleetList.sortBy == 'vslOwner') }" [icon]= "(FleetList.sortBy == 'vslOwner' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('vslOwner', FleetList.sortBy == 'vslOwner' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')">
                <span>Ship Owner</span>
              </snl-th>
              <snl-th [ngClass]="{ 'active':(FleetList.sortBy == 'fleet') }" [icon]= "(FleetList.sortBy == 'fleet' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('fleet', FleetList.sortBy == 'fleet' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')">
                <span>Fleet</span>
              </snl-th>
              <snl-th [ngClass]="{ 'active':(FleetList.sortBy == 'scbrPoints') }" class="scrbPointwdth" [icon]= "(FleetList.sortBy == 'scbrPoints' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('scbrPoints', FleetList.sortBy == 'scbrPoints' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')" *ngIf="FleetList.fleet !='SNAPS'">
                <span>Scrubber Points</span>
              </snl-th>
              <snl-th textStyle="right" class="poolPointwdth" [ngClass]="{ 'active':(FleetList.sortBy == 'poolPoint') }" [icon]= "(FleetList.sortBy == 'poolPoint' && FleetList.sortValue == 'desc') ? 'fa fa-sort-down' : 'fa fa-sort-up'"  (click)="sorting('poolPoint', FleetList.sortBy == 'poolPoint' && FleetList.sortValue == 'desc' ? 'asc' : 'desc')" >
                <span class="col-gap-8 df-c">
                  <span>Pool Points</span>
                </span>
              </snl-th>
              <snl-th>
                <span></span>
              </snl-th>
            </snl-row>
            <ng-container *ngIf="!FleetList.isSkelton">
              <snl-row class="cursor-pointer" *ngFor="let vessel of FleetList.subPoolVessels ; let i = index" snlRowAction  (onRowClick)="rowClick($event,vessel)" [active]="rowActive(vessel.vslNumber)" [ngClass]="{ 'active':rowActive(vessel.vslNumber) }" [disabled]="false">
                <snl-td>
                  <snl-checkbox *ngIf="FleetList.iCheckBox" (onClick)="selectVessel(vessel.vslNumber);$event.stopPropagation()" [checked]="checkBox(vessel.vslNumber)" td__checkbox></snl-checkbox>
                  <span class="CommonPillsMain color__primary">
                    {{vessel.vslName}}
                    <span class="CommonPills fw-400">
                      {{vessel.vslNumber}}
                    </span>
                  </span>
                </snl-td>
                <snl-td *ngIf="FleetList.tab == 'all'" class="no-checkbx" textStyle="left"><span class="color__primary">{{vessel.subPool}}</span></snl-td>
                <snl-td class="no-checkbx" textStyle="left"><span class="color__primary">{{vessel.vslClass}}</span></snl-td>
                <snl-td class="no-checkbx" textStyle="left"><span class="color__primary">{{vessel.vslOwner | shipowners:FleetList.owners}}</span></snl-td>
                <snl-td class="no-checkbx"><span class="color__primary">{{vessel.fleet}}</span></snl-td>
                <snl-td class="no-checkbx scrbPointwdth" textStyle="right"  *ngIf="FleetList.fleet !='SNAPS'"><span class="color__primary">{{vessel.scbrPoints ? (vessel.scbrPoints | number : '1.2-2') : "-"}}</span></snl-td>
                <snl-td class="no-checkbx poolPointwdth" textStyle="right"><span class="color__primary">{{vessel.poolPoint | number : '1.2-2'}}</span></snl-td>
                <snl-td class="no-checkbx"> 
                  <div class="action" (click)="$event.stopPropagation()">
                    <snl-icon class="three-dot df-c" td__ellipsis icon="fa fa-ellipsis"></snl-icon>
                    <div class='custom-dropdwn body-b1'>
                      <span *ngIf="!vessel.updatedPoolPoint" (click) = "shipAction('edit_ship',vessel);$event.stopPropagation()">Modify Pool Points</span>
                      <span *ngIf="vessel.updatedPoolPoint" (click) = "shipAction('revert_poolpoint',vessel);$event.stopPropagation()">Revert to Nominal Pool Points</span>
                      <span *ngIf="!vessel.penaltyValue" (click) = "shipAction('add_penalty',vessel);$event.stopPropagation()">Add Penalty</span>
                      <span *ngIf="vessel.penaltyValue && checkEffectiveDate(vessel.penaltyEffectiveDate,vessel.penaltyEffectiveTime) && !vessel.penaltyCloseEffectiveDate" (click) = "shipAction('edit_penalty',vessel);$event.stopPropagation()">Edit Penalty</span>
                      <span *ngIf="vessel.penaltyValue && checkEffectiveDate(vessel.penaltyEffectiveDate,vessel.penaltyEffectiveTime) && !checkEffectiveDate(vessel.penaltyCloseEffectiveDate,vessel.penaltyCloseEffectiveTime)" (click) = "shipAction('revert_close_penalty',vessel);$event.stopPropagation()">Revert Close Penalty</span>
                      <span *ngIf="vessel.penaltyValue && !checkEffectiveDate(vessel.penaltyEffectiveDate,vessel.penaltyEffectiveTime)" (click) = "shipAction('revert_penalty',vessel);$event.stopPropagation()">Revert Penalty Changes</span>
                      <span *ngIf="!vessel.updatedStatus || vessel.updatedStatus==''" (click)="shipAction('status',vessel);$event.stopPropagation()">
                        <ng-container *ngIf="vessel.iActive; else inActive">Mark as Inactive</ng-container>
                        <ng-template #inActive>Mark as Active</ng-template>
                      </span>
                      <span *ngIf="vessel.updatedStatus && !vessel.isNew &&  vessel.updatedStatus!=''" (click)="shipAction('revert_status',vessel);$event.stopPropagation()">
                        <ng-container *ngIf="vessel.updatedStatus=='active'; else inActiveRevert">Revert to Inactive Status</ng-container>
                        <ng-template #inActiveRevert>Revert to Active Status</ng-template>
                      </span>
                      <span *ngIf="vessel.isNew" (click)="shipAction('delete_ship',vessel);$event.stopPropagation()">
                        <ng-container>Revert Activation & Delete Ship</ng-container>
                      </span>
                    </div>
                  </div>
                </snl-td>
    
              </snl-row>

                 <!-- No Records Found Row -->
                 <tr  *ngIf="FleetList.subPoolVessels.length === 0 && !FleetList.iNotShip">
                    <td  *ngIf="FleetList.tab == 'all'" colspan="7">
                      <div class="body-b1 text-icon data-text d-flex noRecordsFound">
                        <span class="d-flex text__center DataNotAvailable">No Records Found</span>
                      </div>
                    </td>
                    <td  *ngIf="FleetList.tab != 'all'" colspan="6">
                      <div class="body-b1 text-icon data-text d-flex noRecordsFound">
                        <span class="d-flex text__center DataNotAvailable">No Records Found</span>
                      </div>
                    </td>
                  </tr>

            </ng-container>

            <ng-container *ngIf="FleetList.isSkelton">
            <snl-row *ngFor="let number of [0,1,2,3,4,5]"> 
              <snl-td *ngIf="FleetList.tab == 'all'" class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td> 
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td> 
            </snl-row>
            </ng-container>
            <!-- Table Data Rows End-->
          </snl-table>
        </ng-container>
        <ng-container *ngIf="FleetList.iNotShip">
          <div class="d-flex flex-column not-found">
              <div class="d-flex flex-column align-items-center justify-content-center">
                  <div class="image-area d-flex">
                    <img src="assets/img/ship-placeholder.svg" alt="img">
                  </div> 
                  <span class="sub-heading-s2 fw-700 color__secondary">You don’t have any ships yet!</span>
                  <span class="body-b1">There are no ships in the selected Sub pool yet.</span>
                 
              </div>
          </div>
        </ng-container>
      </div> 

    </div>
    <!-- Container Card End  -->
  </div>
  
  <div class="BottomStickyBar">
    <div class="Skelton-section" *ngIf="FleetList.isSkelton">
      <div class="left-side"> 
        <div class="sektion-btm"><span class="Skelton-pp"></span></div>
        <div class="sektion-btm"><span class="Skelton-pp"></span></div>
        <p><span class="Skelton-pp"></span></p>
        <p><span class="Skelton-pp"></span></p>
        </div>
    </div>
    <snl-action-panel *ngIf="!FleetList.isSkelton">
      <div left-side class="df-c">
        <snl-button [size]="'small'" (buttonClick)="addNewShipFrom()">Add Ships</snl-button>
        <ng-container *ngIf="FleetList.subPoolVessels.length != 0">
          <div class="divider"></div>
          <div class="buttons-grp" [ngClass]="{ 'DisabledBtn':filters.vslNumber.length == 0 }"> 
            <snl-button [size]="'small'" [type]="'secondary'" [disabled] = 'filters.vslNumber.length == 0'> 
              <span class="df-c col-gap-8">
                  <span>Download</span>
              </span>
              <!-- Drop down -->
              <div class="custom-dropdwn top-direc left-direc d-flex flex-column align-items-start body-b1">
                <a href="javascript:void(0);" (click)="createPdf()">As PDF</a>
                <a href="javascript:void(0);" (click)="createXlxs()">As .XL sheet</a>
              </div>
            </snl-button>
          </div>
          <snl-button class="move-ship" [size]="'small'" (buttonClick)="moveShip()" [type]="'secondary'"  [disabled] = 'filters.vslNumber.length == 0' style="margin:0 20px;">Move</snl-button>
          <span class="select-section" *ngIf="filters.vslNumber.length == 0">Please select a ship to continue</span>
          <span class="ship-selection" *ngIf="filters.vslNumber.length > 0">{{filters.vslNumber.length}}/ {{FleetList.subPoolVessels.length}} ships selected</span>
          <span class="clear-section" *ngIf="filters.vslNumber.length > 0 && filters.vslNumber.length != FleetList.subPoolVessels.length "><a href="javascript:void(0);" (click)="allSelectClick();$event.stopPropagation()">Select all</a></span>
          <span class="clear-section" *ngIf="filters.vslNumber.length > 0"><a href="javascript:void(0);" (click)="clearSection()">Clear selection </a></span>
        </ng-container>
        
      </div> 
    </snl-action-panel>
  </div>
 
</div>

<app-add-ship *ngIf="FleetList.iNewShipForm" [iNewShipForm] ="FleetList.iNewShipForm" [subpool] ="FleetList.subPools" [tab] ="FleetList.tab"  (closeShip) = "closeShip($event)"></app-add-ship>
<app-ship-detail *ngIf="FleetList.iShipDetail" [iShipDetail] ="FleetList.iShipDetail" [vslNumber] = "FleetList.vslNumber" [owners] ="FleetList.shipOwners"  [subpool] ="FleetList.subpool"  (closeShipDetail) = "closeShipDetail($event)"></app-ship-detail>
<app-mark-as-status *ngIf="FleetList.iStatusForm" [iStatusForm] ="FleetList.iStatusForm" [shipDetail] = "shipDetail" (closeMarkAsStatus) = "closeMarkAsStatus($event)"></app-mark-as-status>
<app-add-edit-penalty *ngIf="FleetList.iPenaltyForm" [iPenaltyForm] ="FleetList.iPenaltyForm" [iAddPenaltyForm] ="FleetList.iAddPenaltyForm" [iEditPenaltyForm] ="FleetList.iEditPenaltyForm" [shipDetail] = "shipDetail" (closePenality) = "closePenality($event)"></app-add-edit-penalty>
<app-edit-ship-details *ngIf="FleetList.iEditShipForm" [iEditShipForm] ="FleetList.iEditShipForm" [shipDetail] = "shipDetail" [owners] ="FleetList.shipOwners"  [subpool] ="FleetList.subpool" (closeEditShip) = "closeEditShip($event)"></app-edit-ship-details>

<app-confirm-modal *ngIf="FleetList.iConfirmModal" [iConfirmModal] ="FleetList.iConfirmModal" [title]="FleetList.confirmModalTitle" [description]="FleetList.confirmModalDescription"  (onAction) = "onAction($event)"></app-confirm-modal>

<snl-modal *ngIf="FleetList.iMoveShip" class="model__customize move-ship" [settings]="FleetList.setting" (modalClose)="FleetList.iMoveShip = false" [type]="'medium'" [open]="FleetList.iMoveShip">
  <div slot="heading">Move {{filters.vslNumber.length}} Ship{{(filters.vslNumber.length>1)?'s':''}} to Sub Pool</div>
  <div slot="modalContent" style="margin-top: 24px;">
    <div class="d-flex">
        <div class="half-containers form-field">
          <form [formGroup]="moveShipForm">
            <div class="CustomizeInput dropdown-customize">
              <label class="body-b labels color__primary">Sub Pool</label>
              <ng-select class="btm-border-select" [items]="FleetList.moveSubPools" [searchable]="false" formControlName="subPool" [ngClass]="{ 'is-invalid': (moveShipForm.controls['subPool'].hasError('required')) && FleetList.moveShipSubmit}">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <span [innerHTML]="item"></span>
                  </ng-template>
              </ng-select>
            </div>
          </form>
        </div>
    </div>
  </div>
  <div slot="modalFooter">
      <snl-button size="small" (buttonClick)="moveShipToSubpool()">Save</snl-button>
      <snl-button size="small" type="secondary" (buttonClick)="closeShipToSubpool()">Cancel</snl-button>
  </div>
</snl-modal>


